var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider__delete",on:{"click":_vm.displayAlert}})}
var staticRenderFns = []

export { render, staticRenderFns }